import { SideDrawer } from "@/components/common/SideDrawer";
import { CompactTaskList } from "@/resources/tasks/components/task-list/CompactTaskList";
import { TaskDetailsDialog } from "@/resources/tasks/components/task-dialogs/TaskDetailsDialog";
import { useState } from "react";
import { useRecordContext } from "react-admin";
import { ResourceName, Task } from "@/types";
import Button from "@/components/ui/Button";
import { ButtonStyleType, ColorType } from "@/types/shared/uiComponents";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { CreateInDialog } from "@/components/common/CreateInDialog";

interface UserTaskDrawerProps {
  drawerExpanded: boolean;
  toggleDrawer: () => void;
}

export const UserTaskDrawer: React.FC<UserTaskDrawerProps> = ({ drawerExpanded, toggleDrawer }) => {
  const user = useRecordContext();

  const [open, setOpen] = useState(false);
  const [openTaskCreateDialog, setOpenTaskCreateDialog] = useState(false);
  const [selected, setSelected] = useState<Task | undefined>();

  if (!user) return null;

  return (
    <>
      <SideDrawer title="Tasks" open={drawerExpanded} onClose={toggleDrawer} hideHandle>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            color={ColorType.Primary}
            onClick={(e) => {
              e.preventDefault();
              setOpenTaskCreateDialog(true);
            }}
            startIcon={<AddIcon />}
            variant={ButtonStyleType.Text}
          >
            Create
          </Button>
        </Box>
        .{/* List */}
        <CompactTaskList
          resource={`users/${user.id}/tasks`}
          onTaskClick={(task: Task) => {
            // <-- open details on row click
            setSelected(task);
            setOpen(true);
          }}
        />
      </SideDrawer>

      <TaskDetailsDialog open={open} task={selected} onClose={() => setOpen(false)} />
      <CreateInDialog
        open={openTaskCreateDialog}
        onClose={() => setOpenTaskCreateDialog(false)}
        resource={ResourceName.TASKS}
      />
    </>
  );
};
